<template>
	<div class="AccountType">
		<!-- <div class="AccountType_center_div">
      <h2>Account Type</h2>
      <div class="AccountType__checkbox">
        <label class="AccountType_input">
          Sales Analytics and Forcasting
          <input
            v-model=" sales_analytics_and_forcasting"
            v-validate="'required'"
            type="checkbox"
            name="account_type"
          >
          <span class="AccountType__checkmark" />
        </label>
        <label class="AccountType_input">
          Inventory Management
          <input
            v-model="inventory_management"
            v-validate="'required'"
            type="checkbox"
            name="account_type"
          >
          <span class="AccountType__checkmark" />
        </label>
        <label class="AccountType_input">
          Expiry Management
          <input
            v-model="expiry_management"
            v-validate="'required'"
            type="checkbox"
            name="account_type"
          >
          <span class="AccountType__checkmark" />
        </label>
        <label class="AccountType_input">
          All
          <input
            v-model="all"
            v-validate="'required'"
            type="checkbox"
            name="account_type"
          >
          <span class="AccountType__checkmark" />
        </label>
        <span
          v-show="errors.has('account_type')"
          class="text-red-dark text-xs"
        >
          Please Account type.
        </span>
      </div>
      <div class="AccountType__btn_section">
        <button @click="goToFinishSetup()">
          Next
        </button>
      </div>
    </div> -->
		<!-- <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    > -->
		<div class="AccountType_center_div">
			<!-- <AccountSettingNavBar /> -->
			<h2 style="word-break: break-word;">
				All NymbleUp products are available for preview under trial period of 30
				days
			</h2>
			<div class="AccountType__checkbox">
				<label class="AccountType_input">
					Sales Analytics and Forcasting
					<input
						v-model="sales_analytics_and_forcasting"
						type="checkbox"
						@change="display_alert = false"
					/>
					<span class="AccountType__checkmark" />
				</label>
				<label class="AccountType_input">
					Inventory Management
					<input
						v-model="inventory_management"
						type="checkbox"
						@change="display_alert = false"
					/>
					<span class="AccountType__checkmark" />
				</label>
				<label class="AccountType_input">
					Workforce Planning
					<input
						v-model="workforce_planning"
						type="checkbox"
						@change="display_alert = false"
					/>
					<span class="AccountType__checkmark" />
				</label>
				<label class="AccountType_input">
					Expiry Management
					<input
						v-model="expiry_management"
						type="checkbox"
						@change="display_alert = false"
					/>
					<span class="AccountType__checkmark" />
				</label>
				<label class="AccountType_input">
					All
					<input v-model="all" type="checkbox" @change="selectAll" />
					<span class="AccountType__checkmark" />
				</label>
				<span v-show="display_alert" class="text-red-dark text-xs">
					Please Account type.
				</span>
			</div>
			<div class="AccountType__btn_section">
				<button class="mr-2" @click="goToUserInformation()">
					Previous
				</button>
				<button @click="goToFinishSetup()">
					Next
				</button>
			</div>
		</div>
		<!-- </el-dialog> -->
	</div>
</template>

<script>
import { serverAddr, EventBus } from "../../networkConfig";
export default {
	name: "AccountType",
	mixins: [],
	props: [],
	data() {
		return {
			sales_analytics_and_forcasting: this.$store.state.userRegistration
				.sales_analytics_and_forcasting,
			all: this.$store.state.userRegistration.all,
			expiry_management: this.$store.state.userRegistration.expiry_management,
			workforce_planning: this.$store.state.userRegistration.workforce_planning,
			inventory_management: this.$store.state.userRegistration
				.inventory_management,
			dialogVisible: true,
			display_alert: false
		};
	},
	mounted() {
		// EventBus.$on("openFinishSetup", account_type_model => {
		// 	this.goToFinishSetup();
		// });
	},
	methods: {
		goToUserInformation() {
			this.$store.commit("showUserInformation", true);
			this.$store.commit("showAccountType", false);
			this.$store.commit("showFinishSetup", false);

			// this.$router.push("/user-registration/user-information");
		},
		goToFinishSetup() {
			if (
				this.all == true ||
				this.sales_analytics_and_forcasting == true ||
				this.expiry_management == true ||
				this.workforce_planning == true ||
				this.inventory_management == true
			) {
				this.$store.commit("FilledAccountType", true);
				this.$store.state.userRegistration.sales_analytics_and_forcasting = this.sales_analytics_and_forcasting;
				this.$store.state.userRegistration.all = this.all;
				this.$store.state.userRegistration.expiry_management = this.expiry_management;
				this.$store.state.userRegistration.inventory_management = this.inventory_management;
				this.$store.state.userRegistration.workforce_planning = this.workforce_planning;
				this.$store.commit("showFinishSetup", true);
				this.$store.commit("showUserInformation", false);
				this.$store.commit("showAccountType", false);

				// this.$router.push({ path: `/user-registration/finish-setup` });
			} else {
				this.display_alert = true;
			}
		},
		selectAll() {
			if (this.display_alert == true) {
				this.display_alert = false;
			}
			if (this.all) {
				this.sales_analytics_and_forcasting = true;
				this.all = true;
				this.expiry_management = true;
				this.inventory_management = true;
				this.workforce_planning = true;
			} else {
				this.sales_analytics_and_forcasting = false;
				this.all = false;
				this.expiry_management = false;
				this.inventory_management = false;
				this.workforce_planning = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AccountType.scss";
@import "../../assets/css/variable.scss";
</style>
<style>
/* Element ui dialog css */
.AccountType .el-icon-close {
	display: none;
}
.AccountType .el-dialog {
	height: auto;
	max-height: 90%;
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}
@media screen and (max-width: 700px) {
	.AccountType .el-dialog {
		width: 90%;
	}
}

.AccountType .el-dialog__body {
	padding: 0 0 30px 0;
}
.AccountType .el-dialog__header {
	@apply p-0;
}
.AccountType .AccountType_button {
	text-align: right !important;
}
.AccountType .el-button--primary {
	background-color: #2c9bce;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
@media screen and (max-width: 576px) {
	.AccountType .AccountType_button {
		margin-top: 20px;
		text-align: center !important;
	}
}
</style>
